import { t } from 'i18next';
import { useMemo, useState } from 'react';
import { Trans } from 'react-i18next';
import { useAuth } from '../../../hooks';
import EmptyPng from '../../../img/empty.png';
import { ContentTVUnit, LicenseAgreement, PrefferedSource, useAccessRequestTVMutation } from '../../../services/content_v1';
import { AccountResType, useGetAccountListQuery } from '../../../services/users_v1';
import { useIsPartnerSource } from '../../common';
import Button from '../Button/Button';
import { CheckBox } from '../CheckBox';
import Form from '../Form';
import ImageLoader from '../ImageLoader';
import { Modal } from '../Modal';
import { RadioInput } from '../RadioInput';
import Select from '../Select';
import TextArea from '../TextArea';
import TextInput from '../TextInput';

interface ContentTVOrderModalProps {
    tvChannels: ContentTVUnit[],
    isOpen: boolean,
    onClose: () => void,
    onSuccess: () => void,
}

export function ContentTVOrderModal({ tvChannels, isOpen, onClose, onSuccess }: ContentTVOrderModalProps) {
    const auth = useAuth();
    const isPartnerSource = useIsPartnerSource();

    const [accessRequest] = useAccessRequestTVMutation();
    // const { data: clients } = useGetAccountListQuery({});
    const { data: consumers } = useGetAccountListQuery({ offset: 0, limit: -1, rtype: AccountResType.CONSUMER });

    const [hasLicense, setHasLicense] = useState(LicenseAgreement.NO);
    const [sources, setSources] = useState(PrefferedSource.ANY);
    const [otherSourceParams, setOtherSourceParams] = useState('');
    const [promocode, setPromocode] = useState('');
    const [wishes, setWishes] = useState('');
    const [testPeriod, setTestPeriod] = useState(7);
    const [forClient, setForClient] = useState<number | undefined>(undefined);

    const availClients = useMemo(() => {
        if (consumers?.results) {
            return consumers.results.data.map((c) => ({ value: c.id, label: c.name }));
        }
        return [];

    }, [consumers?.results])

    const availLicenseAgreement = useMemo(() => {
        return [
            { value: LicenseAgreement.YES, label: t('order:ORDER_MODAL_LIC_YES') },
            { value: LicenseAgreement.PARTIAL, label: t('order:ORDER_MODAL_LIC_PARTIAL') },
            { value: LicenseAgreement.NO, label: t('order:ORDER_MODAL_LIC_NO') },
        ];
    }, []);

    const availSources = useMemo(() => {
        return [
            { value: PrefferedSource.ANY, label: t('tv:ANY_SOURCE') },
            { value: PrefferedSource.MEDIALOGISTIKA, label: t('tv:MEDIALOGISTIC') },
            { value: PrefferedSource.SATELLITE, label: t('tv:SATELLITE') },
            { value: PrefferedSource.OTHER, label: t('tv:OTHER_SOURCE') },
        ];
    }, []);

    return (
        <Modal className="_tv-order" isOpen={isOpen} onClose={() => onClose()}>
            <Form action="#" className="tv-content__order" id="feedback">
                {/* <h2>Ваша заявка <br />на&nbsp;телеканалы · <span>{tvChannels.length}</span></h2> */}
                <h2>
                    <Trans i18nKey="order:ORDER_MODAL_TITLE" values={{ count: tvChannels.length }}></Trans>
                </h2>
                {isPartnerSource && <>
                    <h3><Trans>order:ORDER_MODAL_FOR_WHO</Trans></h3>
                    <Select value={forClient} options={availClients} onChange={(v) => setForClient(v)} />
                </>}
                <div className="tv-content__order-list">
                    {tvChannels.map((unit) => (
                        <div key={unit.id} className="tv-content__order-list-item">
                            {unit.covers?.at(0) ? <ImageLoader url={unit.covers?.at(0)?.url} /> : <img src={EmptyPng} alt="" />}
                            <span className="tv-content__order-list-item-name">{unit.title}</span>
                            <span className="tv-content__order-list-item-theme">{unit.category?.name}</span>
                        </div>
                    ))}
                </div>
                <h3><Trans>order:ORDER_MODAL_HAVE_LIC_MESSAGE</Trans></h3>
                <RadioInput className="tv-content__order-radio" value={hasLicense} items={availLicenseAgreement} onChange={(v) => setHasLicense(v)} />
                <h3><Trans>order:ORDER_MODAL_PREFERENCE_SOURCE</Trans></h3>
                <RadioInput className="tv-content__order-radio" value={sources} items={availSources} onChange={(v) => setSources(v)} />
                {sources === PrefferedSource.OTHER && <TextInput value={otherSourceParams} onChange={(e) => setOtherSourceParams(e.target.value)} placeholder={t('order:ORDER_MODAL_SOURCE_PLACEHOLDER')} />}
                <h3><Trans>order:ORDER_MODAL_PROMO</Trans></h3>
                <TextInput value={promocode} onChange={(e) => setPromocode(e.target.value)} />
                <h3><Trans>order:ORDER_MODAL_WISHES_MESSAGE</Trans></h3>
                <TextArea value={wishes} onChange={(e) => setWishes(e.target.value)} placeholder={t('order:ORDER_MODAL_WISHES_PLACEHOLDER')} />
                <hr style={{ marginBottom: '10px' }} />
                <div className="form__item">
                    <CheckBox value={testPeriod === 7} onChange={(v) => setTestPeriod(v ? 7 : 0)} label={t('order:ORDER_MODAL_TEST_PERIOD_MESSAGE')} />
                </div>
                <p className="tv-content__order-submit">
                    <Button onClick={() => {
                        accessRequest({
                            units: tvChannels.map(unit => unit.id),
                            sender: forClient || auth.account,
                            details: {
                                licagr: hasLicense,
                                pstype: sources,
                                psdetails: otherSourceParams,
                                additional: wishes,
                                promcod: promocode,
                                ontest: testPeriod
                            },
                        }).unwrap().then(() => {
                            onSuccess();
                            onClose();
                        })
                    }}>
                        <Trans>order:ORDER_MODAL_CONFIRM</Trans>
                    </Button>
                </p>
            </Form>
        </Modal>
    );
}